import React from "react";

import { Form, Formik } from "formik";
import * as Yup from "yup";
import InputField from "../../common/InputField";
import FormButtons from "../../common/register/FormButtons";

import { CircleOutlined } from "@mui/icons-material";
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { passwordConditions } from "../../constants/constants";
import { toast, Toaster } from "react-hot-toast";
import { resetPassword } from "../../services/user/UserServices";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Password = (props) => {
  const { t } = useTranslation();
  const { values } = props;
  const navigate = useNavigate();
  const validate = Yup.object({
    password: Yup.string()
      .matches(
        // eslint-disable-next-line
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "Must Contain One Uppercase, One Lowercase, One Number and One Special Case Character"
      )
      .required(t("required")),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Password must match")
      .matches(
        // eslint-disable-next-line
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "Must Contain One Uppercase, One Lowercase, One Number and One Special Case Character"
      )
      .required(t("required")),
  });

  const handleSubmit = async (formik) => {
    const payLoad = {
      email: values.email,
      password: formik.password,
      resetPasswordToken: values.token,
    };
    const result = await resetPassword(payLoad);
    if (result.success) {
      navigate("/login");
    } else {
      // toast.success(result.message);
    }
  };

  return (
    <>
      <Toaster />
      <Formik
        initialValues={{
          password: "",
          confirmPassword: "",
        }}
        validationSchema={validate}
        onSubmit={handleSubmit}
      >
        {() => (
          <Form>
            <Typography
              variant="h4"
              fontWeight="bold"
              color="color.magentaDark1"
            >
              {t("reset-password")}
            </Typography>
            <Box component="div">
              <InputField
                name="password"
                type="password"
                label={t("password")}
                maxLength={35}
              />
              <InputField
                name="confirmPassword"
                type="password"
                label={t("repeat-password")}
                maxLength={35}
              />
            </Box>
            <Typography
              color="color.megentaDark"
              marginTop="3rem"
              fontSize="0.7rem"
            >
              {t("properties-of-password")}
            </Typography>
            <List className="password-rules">
              {passwordConditions?.map((item) => (
                <ListItem disablePadding key={item.id}>
                  <ListItemIcon
                    sx={{
                      minWidth: "auto",
                      fontSize: "10px !important",
                    }}
                  >
                    <CircleOutlined fontSize="0.5rem" />
                  </ListItemIcon>
                  <ListItemText
                    primary={item.name}
                    sx={{
                      fontSize: "10px !important",
                      margin: "0 0 0 0.5rem",
                    }}
                  />
                </ListItem>
              ))}
            </List>

            <FormButtons
              back={() => {
                navigate("/login");
              }}
            />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default Password;
